export default __webpack_public_path__ + "static/media/teacher.a95e7cb1.jpg";